module.exports = __webpack_public_path__ + "6e28ea0f934c930376c25920c549f578.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/visa_2021_chart.png
// module id = 1758
// module chunks = 0